import React from 'react';
import { FetchQuotationUserRfqDetailQuery } from '@generated/graphql';
import { colorSet, clsx } from '@components/Provider';
import RfqDetail from '@routes/Common/RfqDetail';
import RfqDetailHeaderPresenter from '@routes/Common/RfqDetail/RfqDetailHeaderPresenter';
import { makeStyles, Theme } from '@material-ui/core';
interface UseStylesProps {
  matches: boolean;
}

const useStyles = makeStyles<Theme, UseStylesProps>(() => {
  return {
    root: {
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    commonStyle: {
      position: 'fixed',
      backgroundColor: colorSet.gray000,
      borderBottom: `1px solid ${colorSet.gray200}`,
      width: ({ matches }) => (matches ? '100%' : 'calc(100% - 375px)'),
      zIndex: 3,
      padding: 0,
      right: 0
    },
    rfqDeataHeadeer: {
      top: ({ matches }) => (matches ? 0 : 61),
      padding: '8px 16px',
      '& .MuiIconButton-root': {
        width: 32,
        height: 32,
        '& .MuiSvgIcon-root': {
          color: colorSet.gray900,
          '&.favorite': {
            color: colorSet.warningMain
          }
        }
      }
    },
    rfqDetailTab: {
      top: ({ matches }) => (matches ? 49 : 49 + 61),
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      padding: ({ matches }) => (matches ? '0px 16px' : 0)
    },
    userInfo: {
      width: ({ matches }) => (matches ? '100%' : 375),
      marginTop: ({ matches }) => (matches ? -24 : 24),
      '& > div > div + div': {
        marginTop: ({ matches }) => (matches ? 6 : 1),
        '&:last-child': {
          marginBottom: 0
        }
      }
    }
  };
});

interface Props {
  matches: boolean;
  rfqInfo?: FetchQuotationUserRfqDetailQuery;
  extra?: React.ReactNode;
  isPreview?: boolean;
  onChangePath: (_path: string, callback?: () => void) => void;
}

const RequestDetailForm: React.FC<Props> = ({
  matches,
  rfqInfo,
  isPreview,
  onChangePath
}: Props) => {
  const classes = useStyles({ matches });
  const rfqData = rfqInfo?.fetchQuotationUserRfqDetail.data || undefined;
  const projectName = rfqData?.projectName ?? '';

  return (
    <div className={classes.root}>
      {!isPreview && (
        <RfqDetailHeaderPresenter
          className={clsx(classes.commonStyle, classes.rfqDeataHeadeer)}
          title={projectName}
          onClick={() => onChangePath('/dashboard')}
        />
      )}

      <RfqDetail
        matches={matches}
        rfqId={rfqData?.id ?? ''}
        isPreview={true}
        previewData={{
          ...rfqInfo?.fetchQuotationUserRfqDetail.data,
          __typename: undefined
        }}
      />
    </div>
  );
};

export default RequestDetailForm;
